require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("react"), require("react-dom"), require("@tinacms/styles"), require("styled-components"), require("@tinacms/icons")) : "function" == typeof define && define.amd ? define(["exports", "react", "react-dom", "@tinacms/styles", "styled-components", "@tinacms/icons"], e) : e((n = n || self)["@tinacms/react-modals"] = {}, n.React, n.reactDom, n.styles, n.styled, n.icons);
}(this, function (n, r, t, i, e, a) {
  "use strict";

  var o = "default" in e ? e["default"] : e,
      l = r.createContext(null);

  function d() {
    var n = r.useContext(l);
    if (!n) throw new Error("No Modal Container context provided");
    return n;
  }

  var _s = function s() {
    return (_s = Object.assign || function (n) {
      for (var e, t = 1, i = arguments.length; t < i; t++) {
        for (var a in e = arguments[t]) {
          Object.prototype.hasOwnProperty.call(e, a) && (n[a] = e[a]);
        }
      }

      return n;
    }).apply(this, arguments);
  };

  function c(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: e
    }) : n.raw = e, n;
  }

  var p,
      f,
      m,
      u,
      g,
      v,
      h,
      x,
      y,
      b,
      w = o.div.withConfig({
    displayName: "ModalOverlay",
    componentId: "sc-1pd6lc5"
  })(p = p || c(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  overflow: auto;\n  padding: 0;\n  z-index: var(--tina-z-index-4);\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  overflow: auto;\n  padding: 0;\n  z-index: var(--tina-z-index-4);\n"])),
      M = o.div.withConfig({
    displayName: "ModalActions",
    componentId: "sc-165i8ww"
  })(f = f || c(["\n  display: flex;\n  justify-content: flex-end;\n  border-radius: 0 0 5px 5px;\n  padding: 0 var(--tina-padding-big) var(--tina-padding-big)\n    var(--tina-padding-big);\n  ", " {\n    flex: 0 1 auto;\n    min-width: 128px;\n    margin: 0 var(--tina-padding-small) 0 0;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  border-radius: 0 0 5px 5px;\n  padding: 0 var(--tina-padding-big) var(--tina-padding-big)\n    var(--tina-padding-big);\n  ", " {\n    flex: 0 1 auto;\n    min-width: 128px;\n    margin: 0 var(--tina-padding-small) 0 0;\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n"]), i.Button),
      z = o.div.withConfig({
    displayName: "ModalBody",
    componentId: "sc-rstc48"
  })(m = m || c(["\n  padding: ", ";\n  margin: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 160px;\n\n  &:last-child {\n    border-radius: 0 0 5px 5px;\n  }\n"], ["\n  padding: ", ";\n  margin: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 160px;\n\n  &:last-child {\n    border-radius: 0 0 5px 5px;\n  }\n"]), function (n) {
    return n.padded ? "var(--tina-padding-big)" : "0";
  }),
      O = o(function (n) {
    var e = n.children,
        t = n.close,
        i = function (n, e) {
      var t = {};

      for (var i in n) {
        Object.prototype.hasOwnProperty.call(n, i) && e.indexOf(i) < 0 && (t[i] = n[i]);
      }

      if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;

        for (i = Object.getOwnPropertySymbols(n); a < i.length; a++) {
          e.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(n, i[a]) && (t[i[a]] = n[i[a]]);
        }
      }

      return t;
    }(n, ["children", "close"]);

    return r.createElement("div", _s({}, i), r.createElement(C, null, e), t && r.createElement(j, {
      onClick: t
    }, r.createElement(a.CloseIcon, null)));
  }).withConfig({
    displayName: "ModalHeader",
    componentId: "sc-1y46rf7"
  })(u = u || c(["\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--tina-padding-big) 0 var(--tina-padding-big);\n  border-bottom: 1px solid var(--tina-color-grey-3);\n  margin: 0;\n"], ["\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--tina-padding-big) 0 var(--tina-padding-big);\n  border-bottom: 1px solid var(--tina-color-grey-3);\n  margin: 0;\n"])),
      C = o.h2.withConfig({
    displayName: "ModalTitle",
    componentId: "sc-1viz6lr"
  })(g = g || c(["\n  font-size: var(--tina-font-size-4);\n  font-weight: var(--tina-font-weight-regular);\n  line-height: normal;\n  margin: 0;\n"], ["\n  font-size: var(--tina-font-size-4);\n  font-weight: var(--tina-font-weight-regular);\n  line-height: normal;\n  margin: 0;\n"])),
      j = o.div.withConfig({
    displayName: "CloseButton",
    componentId: "sc-zwqigv"
  })(v = v || c(["\n  display: flex;\n  align-items: center;\n  fill: var(--tina-color-grey-5);\n  cursor: pointer;\n  transition: fill 85ms ease-out;\n  svg {\n    width: 24px;\n    height: auto;\n  }\n  &:hover {\n    fill: var(--tina-color-grey-8);\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  fill: var(--tina-color-grey-5);\n  cursor: pointer;\n  transition: fill 85ms ease-out;\n  svg {\n    width: 24px;\n    height: auto;\n  }\n  &:hover {\n    fill: var(--tina-color-grey-8);\n  }\n"])),
      P = e.keyframes(h = h || c(["\n  0% {\n    transform: translate3d( -2rem, 0, 0 );\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d( 0, 0, 0 );\n    opacity: 1;\n  }\n"], ["\n  0% {\n    transform: translate3d( -2rem, 0, 0 );\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d( 0, 0, 0 );\n    opacity: 1;\n  }\n"])),
      k = o.div.withConfig({
    displayName: "FullscreenModal",
    componentId: "sc-ieav2r"
  })(x = x || c(["\n  display: flex;\n  flex-direction: column;\n  z-index: var(--tina-z-index-0);\n  overflow: visible;\n  background-color: #fff;\n  border-radius: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: calc(100% - 170px);\n  max-width: 1500px;\n  height: 100%;\n  animation: ", " 150ms ease-out 1;\n\n  ", " {\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  z-index: var(--tina-z-index-0);\n  overflow: visible;\n  background-color: #fff;\n  border-radius: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: calc(100% - 170px);\n  max-width: 1500px;\n  height: 100%;\n  animation: ", " 150ms ease-out 1;\n\n  ", " {\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n  }\n"]), P, z),
      E = k,
      N = e.keyframes(y = y || c(["\n  0% {\n    transform: translate3d( 0, -2rem, 0 );\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d( 0, 0, 0 );\n    opacity: 1;\n  }\n"], ["\n  0% {\n    transform: translate3d( 0, -2rem, 0 );\n    opacity: 0;\n  }\n\n  100% {\n    transform: translate3d( 0, 0, 0 );\n    opacity: 1;\n  }\n"])),
      I = o.div.withConfig({
    displayName: "PopupModal",
    componentId: "sc-1b6zduo"
  })(b = b || c(['\n  display: block;\n  z-index: var(--tina-z-index-0);\n  overflow: visible; /* Keep this as "visible", select component needs to overflow */\n  background-color: var(--tina-color-grey-1);\n  border-radius: var(--tina-radius-small);\n  margin: 40px auto;\n  width: 460px;\n  max-width: 90%;\n  animation: ', " 150ms ease-out 1;\n"], ['\n  display: block;\n  z-index: var(--tina-z-index-0);\n  overflow: visible; /* Keep this as "visible", select component needs to overflow */\n  background-color: var(--tina-color-grey-1);\n  border-radius: var(--tina-radius-small);\n  margin: 40px auto;\n  width: 460px;\n  max-width: 90%;\n  animation: ', " 150ms ease-out 1;\n"]), N),
      q = I;
  n.FullscreenModal = k, n.Modal = function (n) {
    var e = d().portalNode;
    return e ? t.createPortal(r.createElement(i.TinaReset, null, r.createElement(w, null, r.createElement("div", _s({}, n)))), e) : null;
  }, n.ModalActions = M, n.ModalBody = z, n.ModalFullscreen = E, n.ModalHeader = O, n.ModalOverlay = w, n.ModalPopup = q, n.ModalProvider = function (n) {
    var e = n.children,
        t = r.useState(null),
        i = t[0],
        a = t[1],
        o = r.useCallback(function (n) {
      null !== n && a(n);
    }, []);
    return r.createElement(r.Fragment, null, r.createElement("div", {
      id: "modal-root",
      ref: o
    }), r.createElement(l.Provider, {
      value: {
        portalNode: i
      }
    }, e));
  }, n.PopupModal = I, n.useModalContainer = d, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});